module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('template', {
    slot: "section"
  }, [_c('div', {
    staticClass: "slider"
  }, [(_vm.slides) ? _c('Heading', {
    attrs: {
      "type": "h1"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.currentSlider].title))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.slides), function(slide, index) {
    return _c('li', {
      key: index,
      class: [index === _vm.currentSlider ? 'active' : 'default'],
      attrs: {
        "data-index": index
      },
      on: {
        "click": _vm.setCurrentSlide
      }
    })
  }))], 1)]), _vm._v(" "), _c('template', {
    slot: "aside"
  }, [_c('slider', {
    key: _vm.currentSlider,
    attrs: {
      "index": _vm.currentSlider,
      "slides": _vm.slides
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7046ba8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 143
// module chunks = 0